// extracted by mini-css-extract-plugin
module.exports = {"ShopAddressSettingsForm":"shop-address-settings-section__ShopAddressSettingsForm___1vIp7","AddressesContainer":"shop-address-settings-section__AddressesContainer___3uL6g"};